import { Grid } from "@mui/material";

import { useRouteLoaderData } from "react-router-dom";
import OptimizationBox from "./OptimizationBox";
import OptimizationBoxItemsList from "./OptimizationBoxItemsList";

const CreativeDetail = ({ details }) => {
  const { user_agent: userAgentEnabled } =
    useRouteLoaderData("featureFlagLoader");

  if (!details.on_page_load_js && !userAgentEnabled) return;

  return (
    Object.keys(details || {}).length > 0 && (
      <OptimizationBox panelId={"creative"} title={"Creative"}>
        <Grid container direction="column">
          {details.on_page_load_js && (
            <Grid item>
              <OptimizationBoxItemsList
                title={"On Page Load JS"}
                items={[
                  { key: "on_page_load_js", text: details.on_page_load_js },
                ]}
              />
            </Grid>
          )}
          {details.user_agent && userAgentEnabled && (
            <Grid item>
              <OptimizationBoxItemsList
                title={"User Agent Override"}
                items={[
                  {
                    key: "user_agent",
                    text: details.user_agent,
                  },
                ]}
              />
            </Grid>
          )}
        </Grid>
      </OptimizationBox>
    )
  );
};

export default CreativeDetail;
